import { PIXEL_ID, ACCESS_TOKEN, ENV } from '@shared/conf/env';

import { sha256 } from 'js-sha256';

const generateUniqueEventId = () => Date.now().toString();

const getEventSourceUrl = () => window.location.href;

export const postMetaConverter = async (event_data, user) => {
  const response = await fetch('https://api.ipify.org/?format=json');

  const ip = await response.json();

  const event = {
    event_time: Math.floor(Date.now() / 1000),
    user_data: {
      client_ip_address: ip?.ip,
      client_user_agent: navigator.userAgent,
      em: [user?.user?.email ? sha256(user?.user?.email) : null],
      ph: [null],
    },
    event_source_url: getEventSourceUrl(),
    opt_out: false,
    event_id: generateUniqueEventId(),
    action_source: 'website',
    data_processing_options: [],
    data_processing_options_country: 0,
    data_processing_options_state: 0,
    ...event_data,
  };

  const body = {
    data: [event],
    test_event_code: 'TESTTDH',
  };

  const url = `https://graph.facebook.com/v16.0/${PIXEL_ID}/events?access_token=${ACCESS_TOKEN}`;

  if (ENV === 'prd') {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(res => {
        res.json();
      })
      .catch(err => err);
  } else {
    return '';
  }
};
